/* GOWin® Store — actualización quirúrgica de sugeridos, 2026-08-08.
   Mantiene estable el drawer y corrige restos del shell de carrito vacío. */
(()=>{
  if(window.GowinCartSuggestionSurgicalV3)return;
  window.GowinCartSuggestionSurgicalV3=true;

  const SELECTOR='[data-gowin-drawer-add]';
  let adding=false;

  const closeDrawer=(drawer)=>{
    if(typeof drawer?.close==='function'){
      drawer.close();
      return;
    }
    drawer?.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  };

  const getStaleEmptyShell=(root)=>{
    if(!root)return null;
    const contents=root.id==='CartDrawer'
      ?root
      :root.querySelector?.('#CartDrawer');
    return contents?.querySelector('.drawer__inner > .drawer__inner-empty')||null;
  };

  const sanitizeNonEmptyStructure=(drawer)=>{
    if(!drawer||drawer.classList.contains('is-empty'))return false;
    const stale=getStaleEmptyShell(drawer);
    if(!stale)return false;
    stale.remove();
    return true;
  };

  const resetDrawerScroll=(drawer)=>{
    if(!drawer)return;
    const shell=drawer.querySelector('#CartDrawer');
    const inner=drawer.querySelector('.drawer__inner');
    const items=drawer.querySelector('cart-drawer-items');
    const contents=drawer.querySelector('#CartDrawer-CartItems');
    const suggestions=drawer.querySelector('[data-gowin-drawer-suggestions]');
    [shell,inner,items,contents].forEach(node=>{ if(node)node.scrollTop=0; });
    if(items)items.scrollLeft=0;
    if(contents)contents.scrollLeft=0;
    if(suggestions)suggestions.scrollLeft=0;
  };

  const updateCartBubble=(markup)=>{
    if(!markup)return;
    const currentIcon=document.querySelector('#cart-icon-bubble');
    if(!currentIcon)return;
    const iconDoc=new DOMParser().parseFromString(markup,'text/html');
    const iconSection=iconDoc.querySelector('#shopify-section-cart-icon-bubble,.shopify-section');
    const nextIconHTML=iconSection?.innerHTML?.trim()||iconDoc.body?.innerHTML?.trim();
    if(nextIconHTML)currentIcon.innerHTML=nextIconHTML;
  };

  const bindOverlay=(drawer)=>{
    const overlay=drawer?.querySelector('#CartDrawer-Overlay');
    if(!overlay||overlay.dataset.gowinSurgicalCloseBound==='true')return;
    overlay.dataset.gowinSurgicalCloseBound='true';
    overlay.addEventListener('click',()=>closeDrawer(drawer));
  };

  const patchNonEmptyDrawer=(currentContents,nextContents)=>{
    const currentItemsHost=currentContents.querySelector('cart-drawer-items');
    const nextItemsHost=nextContents.querySelector('cart-drawer-items');
    const currentItems=currentContents.querySelector('#CartDrawer-CartItems');
    const nextItems=nextContents.querySelector('#CartDrawer-CartItems');
    const currentErrors=currentContents.querySelector('#CartDrawer-CartErrors');
    const nextErrors=nextContents.querySelector('#CartDrawer-CartErrors');
    const currentFooter=currentContents.querySelector('.drawer__footer');
    const nextFooter=nextContents.querySelector('.drawer__footer');
    if(!currentItemsHost||!nextItemsHost||!currentItems||!nextItems||!currentFooter||!nextFooter)return false;
    currentItems.innerHTML=nextItems.innerHTML;
    currentFooter.innerHTML=nextFooter.innerHTML;
    currentItemsHost.className=nextItemsHost.className;
    if(currentErrors&&nextErrors)currentErrors.innerHTML=nextErrors.innerHTML;
    return true;
  };

  const refreshDrawer=async(drawer)=>{
    const root=window.Shopify?.routes?.root||'/';
    const separator=root.includes('?')?'&':'?';
    const response=await fetch(`${root}${separator}sections=cart-drawer,cart-icon-bubble`,{headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},cache:'no-store'});
    if(!response.ok)throw new Error('No se pudo actualizar el carrito');
    const sections=await response.json();
    const drawerMarkup=sections['cart-drawer'];
    if(!drawerMarkup)throw new Error('No se recibió el contenido del carrito');
    const parsed=new DOMParser().parseFromString(drawerMarkup,'text/html');
    const nextDrawer=parsed.querySelector('cart-drawer');
    const nextContents=parsed.querySelector('#CartDrawer');
    const currentContents=drawer.querySelector('#CartDrawer');
    if(!nextContents||!currentContents)throw new Error('El carrito no pudo renderizarse');
    const staleEmptyShell=currentContents.querySelector('.drawer__inner > .drawer__inner-empty');
    const currentIsEmpty=drawer.classList.contains('is-empty')||Boolean(staleEmptyShell);
    const nextIsEmpty=nextDrawer?.classList.contains('is-empty')||false;
    let patched=false;
    if(!currentIsEmpty&&!nextIsEmpty)patched=patchNonEmptyDrawer(currentContents,nextContents);
    if(!patched)currentContents.innerHTML=nextContents.innerHTML;
    drawer.classList.toggle('is-empty',nextIsEmpty);
    if(!nextIsEmpty)getStaleEmptyShell(currentContents)?.remove();
    drawer.classList.add('animate','active');
    document.body.classList.add('overflow-hidden');
    bindOverlay(drawer);
    resetDrawerScroll(drawer);
    requestAnimationFrame(()=>{resetDrawerScroll(drawer);requestAnimationFrame(()=>resetDrawerScroll(drawer));});
    updateCartBubble(sections['cart-icon-bubble']);
    document.dispatchEvent(new CustomEvent('cart:updated',{detail:{source:'gowin-drawer-add'}}));
  };

  const handleAdd=async(event)=>{
    const button=event.target.closest?.(SELECTOR);
    if(!button||adding)return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const drawer=button.closest('cart-drawer')||document.querySelector('cart-drawer');
    if(!drawer)return;
    const variantId=button.dataset.gowinDrawerAdd||button.dataset.variantId;
    if(!variantId)return;
    adding=true;
    const label=button.querySelector('span');
    const original=label?.textContent||button.textContent||'Agregar';
    button.setAttribute('aria-busy','true');
    button.disabled=true;
    if(label)label.textContent='Agregando…';
    try{
      const payload=new FormData();
      payload.append('id',variantId);
      payload.append('quantity','1');
      const response=await fetch(window.routes?.cart_add_url||'/cart/add.js',{method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:payload});
      const state=await response.json();
      if(!response.ok||state.status)throw new Error(state.description||'No se pudo agregar el producto');
      await refreshDrawer(drawer);
    }catch(error){
      if(label)label.textContent='Intenta otra vez';
      button.removeAttribute('aria-busy');
      button.disabled=false;
      setTimeout(()=>{if(button.isConnected&&label)label.textContent=original;},1800);
    }finally{adding=false;}
  };

  const init=()=>{
    const drawer=document.querySelector('cart-drawer');
    sanitizeNonEmptyStructure(drawer);
    bindOverlay(drawer);
    resetDrawerScroll(drawer);
  };

  document.addEventListener('click',handleAdd,true);
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init,{once:true}):init();
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('cart:updated',()=>requestAnimationFrame(()=>{const drawer=document.querySelector('cart-drawer');sanitizeNonEmptyStructure(drawer);bindOverlay(drawer);}));
})();
